import React, { SVGProps } from 'react'

export const CorkscrewSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#2E2A29"
      d="M2 5.5A2.5 2.5 0 0 1 4.5 3h15a2.5 2.5 0 0 1 0 5H13v1.333a2 2 0 0 1-1.23 1.847l-2.802 1.167 4.68 1.404c1.79.537 1.931 3.017.214 3.753l-2.486 1.066 1.071.536a1 1 0 1 1-.894 1.788l-1.072-.535c-1.523-.762-1.458-2.957.107-3.628l2.486-1.065-4.68-1.404c-1.8-.54-1.93-3.039-.195-3.762L11 9.333V8H4.5A2.5 2.5 0 0 1 2 5.5Z"
    />
  </svg>
)
